<template>
  <div class="GroupBuyProgress">
    <ul v-if="taskList.length" class="steps">
      <li class="steps-line steps-line-left">
        <div class="steps-item">
          <div
            class="steps-border"
            :class="{ 'steps-border-linght': !taskList[0].isFinish }"
          ></div>
        </div>
      </li>
      <li
        v-for="(item, index) in taskList"
        :key="index"
        class="steps-line"
        :class="{
          'steps-line-left': (index + (taskList.length % 2)) % 2,
          'steps-line-right': !((index + (taskList.length % 2)) % 2),
        }"
      >
        <div class="steps-item">
          <div
            class="steps-border"
            :class="{
              'steps-border-linght': !item.isFinish,
              'steps-border-half': item.isFirstUnfinish,
            }"
          ></div>
          <span v-if="item.isFinish" class="point" :class="{'first-point': item.firstFinish}"></span>
          <span
            v-if="item.isFinish && item.firstFinish"
            class="current-point"
          ></span>
          <div class="connect-line"></div>
          <div class="content">
            <div class="content-line person-info-box">
              <div>
                <div class="person-list">
                    <span class="invite-person" v-if="!item.isShowBuy && !item.isFinish">
                      再邀<span class="person-num">{{item.taskNeedNumber - item.userList.length}}</span>人，得
                    </span>
                </div>
                <div class="welfare-img-box">
                  <img
                    v-if="item.welfareImage"
                    class="welfare-img"
                    :src="`${imgAddr}${item.welfareImage}${ailoss}`"
                    @click="imageView(`${imgAddr}${item.welfareImage}`)"
                    alt=""
                  />
                </div>
              </div>
              <div>
                <div class="person-logo-box">
                  <div
                    v-for="(user, userIndex) in item.userList"
                    :key="userIndex"
                    class="person-logo"
                  >
                    <img class="logo-img" :src="user.wechatHeadImg" alt="" />
                    <img
                      v-if="user.writeOff"
                      class="seal"
                      :src="imgList[0]"
                      alt=""
                    />
                  </div>
                </div>
                <div
                  class="flag-box"
                  :class="{
                  'flag-box-red': !item.isFinish,
                  'flag-box-grey': disabledClick,
                }"
                  :style="{backgroundImage: item.isFinish ? `url('${imgAddr}oppeinAI/32lovehome/user/group-buy/btn-bg.png')` : 'unset'}"
                  @click="onInvite(item)"
                >
                    <!-- @click="onInvite(item)" -->
                  <i v-if="item.isFinish" class="iconfont icon-dagou" />

                  <span v-if="item.isShowBuy"> {{ groupType }}</span>
                  <span v-else-if="item.isFinish">
                    已拼{{ item.finishNum }}人
                  </span>
                  <span v-else>
                    去邀请
                  </span>
                </div>
                <div class="time">
                  <!-- 2022-01-01 18:30 -->
                  <span v-if="item.finishTime" class="time-text">
                  {{ item.finishTime | formatDate('YYYY/MM/DD HH:mm:ss') }}
                  </span>
                </div>
              </div>

            </div>
            <div v-if="item.prizeDescription" class="description">
              {{ item.prizeDescription }}
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
  import { ImagePreview } from 'vant';
export default {
  name: 'GroupBuyProgress',
  components: {},
  props: {
    groupInfo: {
      type: Object,
      default: () => {
        return {}
      },
    },
    type: {
      type: Number,
      default: 0,
    },
    disabledClick: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    groupInfo() {
      this.getData()
    },
  },
  computed: {
    ailoss() {
      return '?x-oss-process=image/resize,m_pad,w_650,h_600,color_FFFFFF,limit_0/auto-orient,0/quality,Q_90';
    },
  },
  data() {
    return {
      imgAddr: systemConfig.imageServer,
      imgList: ['seal.png'],
      groupType: '', // 拼团类型，购卡、秒杀
      list: [{}, {}, {}, {}],
      taskList: [],
      userList: [],
      invitePeople: null,
      owner: null,
    }
  },
  created() {
    this.$fission.setImgAddress('user/group-buy/', this.imgList, true, true)
    this.getData()
  },
  methods: {
    deepCopy(object) {
      return JSON.parse(JSON.stringify(object))
    },
    getData() {
      const typeMap = {
        50: '购卡',
      }
      this.groupType = typeMap[this.type]
      if (!this.groupInfo) return
      const groupPurchaseVO = this.groupInfo.groupPurchaseVO
      this.taskList = this.deepCopy(groupPurchaseVO.groupPurchaseTaskList)
      this.userList = groupPurchaseVO.groupPurchaseLogList
        ? this.deepCopy(groupPurchaseVO.groupPurchaseLogList)
        : []
      this.userList.sort(
        (first, second) => first.lastUpdateDt - second.lastUpdateDt
      )
      this.invitePeople =
        groupPurchaseVO.invitePeople ||
        groupPurchaseVO.groupPurchase.virtualGroupHeadImage
      this.owner = this.userList.find((item) => {
        return (
          item.userAccountId === groupPurchaseVO.groupPurchaseItem.userAccountId
        )
      })
      let userList = this.deepCopy(this.userList)
      let isFirstUnfinish = true
      let finishNum = 0
      this.taskList.forEach((task, index) => {
        this.$set(task, 'userList', [])
        if (index > 0) {
          task.taskNeedNumber =
            task.taskNumber - this.taskList[index - 1].taskNumber
        } else {
          task.taskNeedNumber = task.taskNumber
        }
        if (userList.length) {
          task.userList = userList.splice(0, task.taskNeedNumber)
          if(task.userList.length > 5) {
            task.userList.splice(5);
          }
        }

        task.isFinish = task.userList.length === task.taskNeedNumber

        // 设置第一个未完成任务标识，用于显示半条进度条
        if (!task.isFinish && isFirstUnfinish) {
          task.isFirstUnfinish = isFirstUnfinish
          isFirstUnfinish = false
        }

        // 获取任务完成时间
        task.finishTime = task.isFinish
          ? task.userList[task.userList.length - 1].lastUpdateDt || ''
          : ''

        // 第一阶段任务显示购买任务
        if (index === 0 && task.taskNeedNumber == 1) {
          task.isShowBuy = true
          // if (this.invitePeople) {
          //   task.userList.unshift({
          //     wechatHeadImg: `${this.imgAddr}${this.invitePeople}`,
          //   })
          // }
        } else if (task.userList.length) {
          finishNum += task.userList.length
          task.finishNum = finishNum
          // 添加发起人头像
          // task.userList.unshift(this.owner)
        }
      })

      if (userList.length) {
        // 已核销的排序
        userList.sort((a, b) => b.writeOff - a.writeOff)
        userList.forEach((user) => {
          this.taskList.push({
            taskNumber: 1,
            isFinish: true,
            finishNum: ++finishNum,
            finishTime: user.lastUpdateDt || '',
            userList: [
              // this.owner,
              user,
            ],
          })
        })
      }
      this.taskList.reverse()
      let isFristFinish = true
      this.taskList.forEach((item) => {
        if (item.isFinish && isFristFinish) {
          item.firstFinish = true
          isFristFinish = false
        }
      })
    },
    onInvite(item) {
      if (item.isFinish) return
      if (this.disabledClick) return
      this.$emit('onInvite')
    },
    imageView(url) {
      ImagePreview({images:[url],closeable: true});
    }
  },
}
</script>

<style scoped lang="less">
@stepsItemHeight: 70px;
.GroupBuyProgress {
  padding-bottom: 20px;
  .steps {
    margin: auto;
    padding: 20px 0;
    width: 100%;
    max-width: 400px;
    color: #333;
    font-size: 11px;
    &-line {
      position: relative;
      width: 100%;
      display: flex;
    }
    &-line-left {
      justify-content: start;
      .steps-item {
        padding-right: 10px;
        .steps-border {
          right: -3px;
        }
        .point {
          right: -6px;
        }
        .first-point {
          right: -7px;
        }
        .current-point {
          right: -8px;
        }
        .person-info-box {
          padding-right: 25px;
        }
        .person-logo-box {
          margin-right: 5px;
        }
        .seal {
          top: -77%;
          right: 25%;
        }
      }
      .welfare-img-box{
        margin-right: 12px;
      }
    }
    &-line-right {
      justify-content: flex-end;
      .steps-item {
        padding-left: 10px;
        text-align: right;
        .connect-line {
          left: 0px;
        }
        .steps-border {
          left: -3px;
        }
        .point {
          left: -6px;
        }
        .first-point {
          left: -7px;
        }
        .current-point {
          left: -8px;
        }
        .content-line {
          flex-direction: row-reverse;
        }
        .person-info-box {
          padding-left: 25px;
        }
        .person-logo-box {
          margin-left: 5px;
        }
        .seal {
          top: -77%;
          right: -85%;
        }
        .description{
          padding-right: 0 !important;
          padding-left: 25px;
        }
      }
      .welfare-img-box{
        margin-left: 12px;
      }
    }
    &-item {
      position: relative;
      flex-basis: 50%;
      height: @stepsItemHeight;
      box-sizing: border-box;
      .steps-border {
        position: absolute;
        z-index: 10;
        width: 6px;
        height: @stepsItemHeight;
        background: #ff7777;
      }
      .steps-border-linght {
        background: #ffd3d3;
      }
      .steps-border-half::after {
        position: absolute;
        bottom: 0;
        display: block;
        content: '';
        width: 100%;
        height: 50%;
        background: #ff7777;
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
      }
      .point {
        position: absolute;
        top: 0;
        z-index: 11;
        width: 12px;
        height: 12px;
        background: #e71d1d;
        border-radius: 50%;
      }
      .first-point {
        background: #fff;
        border: 1px solid #e71d1d;
      }
      .current-point {
        position: absolute;
        top: -1px;
        z-index: 10;
        display: block;
        width: 16px;
        height: 16px;
        background: #e03030;
        border-radius: 50%;
        opacity: 0.4;
        animation: twinkling 1s infinite ease-in-out;
      }
      .connect-line {
        position: absolute;
        top: 6px;
        right: 0;
        z-index: 1;
        width: 23px;
        height: 2px;
        border-top: 1px solid #e9001e;
      }
      .person-list{
        margin-bottom: 5px;
        height: 18px;
        display: flex;
        align-items: flex-end;
        width: 100%;
        box-sizing: border-box;
        .person-num{
          color: #E72020;
        }
      }
      .person-logo-box {
        margin-bottom: 5px;
        display: flex;
        height: 20px;
        .person-logo:first-child{
          margin-left: 3px !important;
        }
        .person-logo {
          position: relative;
          margin-left: -13px;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          .logo-img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }
          .seal {
            position: absolute;
            width: 45px;
            height: 45px;
          }
        }
      }
      .content {
        position: absolute;
        top: -31px;
        left: 0;
        right: 0;
        height: @stepsItemHeight;

        &-line {
          margin-bottom: 5px;
          display: flex;
          justify-content: flex-end;
          align-items: flex-start;
        }

        .flag-box {
          position: relative;
          z-index: 10;
          margin-bottom: 5px;
          padding: 5px 0;
          min-width: 52px;
          white-space: nowrap;
          color: #fff;
          background: #f8d264;
          border-radius: 20px;
          text-align: center;
          background-size: 100% 100%;
          background-repeat: no-repeat;
          overflow: hidden;
          flex-shrink: 0;
          .iconfont {
            font-size: 12px;
          }
        }
        .flag-box-red {
          background-color: #e71d1d;
        }
        .flag-box-grey {
          background-color: #ccc;
        }
        .welfare-img-box {
          width: 65px;
          height: 60px;
          .welfare-img {
            width: 100%;
            border-radius: 5px;
            height: 100%;
          }
        }
        .time {
          flex: 1;
          font-size: 10px;
          text-align: center;
          .time-text {
            display: inline-block;
            max-width: 90px;
          }
        }
        .description {
          margin-top: 3px;
          width: 100%;
          box-sizing: border-box;
          word-break: break-all;
          padding-right: 25px
        }
      }
    }
    &-line:first-child {
      height: 40px;
      .steps-border {
        height: 40px;
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
      }
    }
    &-line:last-child {
      .steps-border {
        border-bottom-left-radius: 20px;
        border-bottom-right-radius: 20px;
        overflow: hidden;
      }
    }
  }
}
@media (max-width: 320px) {
  .flag-box {
    padding: 5px 4px !important;
  }
  .steps-line-left .welfare-img-box{
    margin-right: 10px !important;
  }
  .steps-line-right .welfare-img-box{
    margin-left: 10px !important;
  }
  .flag-box{
    font-size: 10px !important;
    min-width: 39px !important;
  }
  .welfare-img-box{
    width: 50px !important;
    height: 38px !important;
  }
}
@media (max-width: 360px) {
  .steps-line-left .welfare-img-box{
    margin-right: 10px !important;
  }
  .steps-line-right .welfare-img-box{
    margin-left: 10px !important;
  }
}
@keyframes twinkling {
  0% {
    opacity: 0.2;
    -webkit-transform: scale(1);
  }
  50% {
    opacity: 0.5;
    -webkit-transform: scale(1.5);
  }
  100% {
    opacity: 0.2;
    -webkit-transform: scale(1);
  }
}
</style>
